import React, { useContext, useEffect, useState } from 'react';
import AdminContext from '../../StateContext/Application';

const GrievanceDashboard = () => {
    const context = useContext(AdminContext);
    const { TotalTicketInfoForDashboard,Usermenu } = context;
    const [ticketStats, setTicketStats] = useState({
        raised: 0,
        resolved: 0,
        pending: 0,
        sendtoHO : 0
    });
     const [adminDatatils, setAdminDatatils] = useState([])
     
     const FetchAdminDetails = async () => {
    try {
      const data = await Usermenu();
      setAdminDatatils(data.Data);
      console.log("Admin Details Fetchedsadata:", data.Data);
    }
    catch (err) {
      console.log(err);
    }
  }
    const fetchData = async () => {
        const data = await TotalTicketInfoForDashboard();
        console.log("Fetched Data:", data);
        const totalRaised =
            data?.result?.[0]?.TotalTicketRaised ?? 0;

        const totalResolved =
            data?.result1?.[0]?.TotalTicketResolved ?? 0;

        const totalPending =
            data?.result2?.[0]?.TotalTicketPending ?? 0;

        const TotalTicketSendToHO =
            data?.result3?.[0]?.TotalTicketSendToHO ?? 0;

        setTicketStats({
            raised: totalRaised,
            resolved: totalResolved,
            pending: totalPending,
            sendtoHO : TotalTicketSendToHO
        });
    };

    useEffect(() => {
        fetchData();
        FetchAdminDetails();
    }, []);
    return (
        <>
            <h3 style={{ textAlign: "center",marginBottom:"1rem" }}>Grievance Dashboard</h3>
            <div>
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "1.5rem",
                    marginBottom: "1.5rem"
                }}>

                    {/* Total Scheme Budget For DMA*/}

                    <div style={{ minWidth: "250px" }}>

                        <div style={{
                            width: "100%",
                            height: "6rem",
                            borderRadius: "14px",
                            background: "#ffffffff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "1rem 1.25rem",
                            boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
                            cursor: "pointer"
                        }}>
                            <div style={{
                                width: "70px",
                                height: "40px",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0
                            }}>
                                <img src="/Total-Scheme-Budget.png" style={{ width: "70px", height: "70px", objectFit: "contain" }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                                <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
                                    Total Tickets :
                                </span>
                                <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                                    {ticketStats.raised}
                                </span>
                            </div>
                            <div>
                                <img src="/Blue-Arrow.png" style={{
                                    width: "42px",
                                    height: "42px",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }} />
                            </div>
                        </div>

                    </div>

                    {/* Total Scheme Budget*/}

                    <div style={{ minWidth: "250px" }}>

                        <div onClick={()=>window.location="/AdminDashboard/ViewTicketForAdmin"} style={{
                            width: "100%",
                            height: "6rem",
                            borderRadius: "14px",
                            background: "#ffffffff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "1rem 1.25rem",
                            boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
                            cursor: "pointer"
                        }}>
                            <div style={{
                                width: "70px",
                                height: "40px",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0
                            }}>
                                <img src="/Total-Scheme-Budget.png" style={{ width: "70px", height: "70px", objectFit: "contain" }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                                <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
                                    Active Tickets :
                                </span>
                                <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                                    {ticketStats.pending}
                                </span>
                            </div>
                            <div>
                                <img src="/Blue-Arrow.png" style={{
                                    width: "42px",
                                    height: "42px",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }} />
                            </div>
                        </div>

                    </div>


                    {/* DMA FUND DONE */}
                    <div style={{ minWidth: "250px" }}>

                        <div onClick={()=>window.location="/AdminDashboard/ClosedTickets"} style={{
                            width: "100%",
                            height: "6rem",
                            borderRadius: "14px",
                            background: "#ffffffff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "1rem 1.25rem",
                            boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
                            cursor: "pointer"
                        }}>
                            <div style={{
                                width: "70px",
                                height: "40px",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0
                            }}>
                                <img src="/Total-Scheme-Budget.png" style={{ width: "70px", height: "70px", objectFit: "contain" }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                                <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
                                     Tickets Resolved :
                                </span>
                                <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                                    {ticketStats.resolved}
                                </span>
                            </div>
                            <div>
                                <img src="/Blue-Arrow.png" style={{
                                    width: "42px",
                                    height: "42px",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }} />
                            </div>
                        </div>

                    </div>


                    {/* Total Fund Transfer To DAO */}

                    <div style={{ minWidth: "250px" }}>
                      
                            <div onClick={()=>window.location="/AdminDashboard/HOTickets"}  style={{
                                width: "100%",
                                height: "6rem",
                                borderRadius: "14px",
                                background: "#ffffffff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "1rem 1.25rem",
                                boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
                                cursor: "pointer"
                            }}>
                                <div style={{
                                    width: "70px",
                                    height: "40px",
                                    borderRadius: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0
                                }}>
                                    <img src="/Total-Fund-Transfer-to-DAO.png" style={{ width: "70px", height: "70px", objectFit: "contain" }} />
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                                    <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
                                      {adminDatatils.Role === "Grievance" ? "Tickets Send To HO :" : "Tickets Forwarded to HO :"}
                                    </span>
                                    <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                                      {ticketStats.sendtoHO}
                                    </span>
                                </div>
                                <div>
                                    <img src="/OrangeArrow.png" style={{
                                        width: "42px",
                                        height: "42px",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }} />
                                </div>
                            </div>
                        
                    </div>

                </div>
            </div>
        </>
    )
}

export default GrievanceDashboard